@use "../../../../../styles/Colors.scss" as Colors;
@use "../../../../../styles/Constants.scss" as Constants;

.TableFilters {
	$border-width: 1px;

	.search {
		margin-right: Constants.$val-spacing-m;
	}
}
